// extracted by mini-css-extract-plugin
module.exports = {"listItem":"bio-module--listItem--35w1P","tekstWrapper":"bio-module--tekstWrapper--2t7Wo","tekst":"bio-module--tekst--2_9OO"};